export const RIDE_AUTOS_DEFAULT_FLOOR = 10;

// Unknown counts fail closed so a transient error never sends a Guest to a market we can't vouch for.
export const meetsRideAutosFloor = (
  count: number | null,
  floor: number = RIDE_AUTOS_DEFAULT_FLOOR,
): boolean => count !== null && count >= floor;
